import Layout from '@/layout'

const miniAppRouter = {
  path: "/merchants/page/manager",
  name:'merchantsIndex',
  hiddeChilden:true,
  hidden:false,
  meta: { title: 'menu.miniProgram', iconClass: 'el-icon-files', module:'miniProgram', roles:['MARKETING_MEMBER']},
  component: Layout,
  children:[
    {
      path: "",
      name: "merchantEdit",
      hidden:false,
      component: () => import( "@/views/mini_program/pageSet"),
      meta: { title: 'menu.miniProgram', iconClass: 'el-icon-files', module:'miniProgram', keepAlive: true, roles:['MARKETING_MEMBER']}
    }
  ]
}

export default miniAppRouter